'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var StoresHorizontalGoogleRu = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 135,
        height: 40,
        fill: "none",
        viewBox: "0 0 135 40"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                fillRule: "evenodd",
                d: "M41.424 7.273q.34-.203.771-.344a3.3 3.3 0 0 1 1.014-.14q.94 0 1.483.445.543.446.543 1.203 0 .601-.363 1.01a1.76 1.76 0 0 1-.927.542v.03q.31.047.587.17.278.12.485.324.209.204.33.476.12.271.121.602 0 .543-.219.912a1.8 1.8 0 0 1-.572.602 2.4 2.4 0 0 1-.79.334 4 4 0 0 1-.873.102q-.466 0-.922-.097a2.9 2.9 0 0 1-.844-.32l.262-.805q.252.126.65.243.397.116.805.116.67 0 1.033-.3a1 1 0 0 0 .364-.805 1 1 0 0 0-.146-.558 1.06 1.06 0 0 0-.379-.345 1.7 1.7 0 0 0-.519-.174 3.4 3.4 0 0 0-.567-.049h-.437V9.65h.437q.3 0 .558-.078.257-.076.446-.218.19-.141.296-.335a.9.9 0 0 0 .106-.437q0-.436-.311-.684-.31-.248-.834-.248-.359.001-.718.116a5 5 0 0 0-.641.252zM47.848 23v1.8h4.3c-.1 1-.5 1.8-1 2.3-.6.6-1.6 1.3-3.3 1.3-2.7 0-4.7-2.1-4.7-4.8s2.1-4.8 4.7-4.8c1.4 0 2.5.6 3.3 1.3l1.3-1.3c-1.1-1-2.5-1.8-4.5-1.8-3.6 0-6.7 3-6.7 6.6s3.1 6.6 6.7 6.6c2 0 3.4-.6 4.6-1.9 1.2-1.2 1.6-2.9 1.6-4.2 0-.4 0-.8-.1-1.1zm11.1-1.3c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3m5 4.3c0-2.5 1.9-4.3 4.3-4.3s4.3 1.7 4.3 4.3c0 2.5-1.9 4.3-4.3 4.3s-4.3-1.9-4.3-4.3m1.9-.1c0 1.5 1.1 2.6 2.4 2.6s2.4-1.1 2.4-2.6c0-1.6-1.1-2.6-2.4-2.6s-2.4 1.1-2.4 2.6m-9.3 0c0 1.5 1.1 2.6 2.4 2.6s2.4-1.1 2.4-2.6c0-1.6-1.1-2.6-2.4-2.6s-2.4 1.1-2.4 2.6m33.1-4.2c2.2 0 3.2 1.7 3.6 2.7l.2.5-5.7 2.4c.5.9 1.1 1.3 2.1 1.3s1.6-.5 2.1-1.2l1.4 1c-.4.7-1.6 1.9-3.5 1.9-2.4 0-4.2-1.9-4.2-4.3 0-2.6 1.8-4.3 4-4.3m-2.2 4.1c0-1.6 1.3-2.5 2.2-2.5.7 0 1.4.4 1.6.9zm-2.8 4.1h-1.9V17.4h1.9zm-4.9-7.3c-.5-.5-1.3-1-2.3-1-2.1 0-4.1 1.9-4.1 4.3s1.9 4.2 4.1 4.2c1 0 1.8-.5 2.2-1h.1v.6c0 1.6-.9 2.5-2.3 2.5-1.1 0-1.9-.8-2.1-1.5l-1.6.7c.5 1.1 1.7 2.5 3.8 2.5 2.2 0 4-1.3 4-4.4v-7.6h-1.8zm-4.6 3.3c0 1.5 1.1 2.6 2.4 2.6s2.3-1.1 2.3-2.6-1-2.6-2.3-2.6-2.4 1.1-2.4 2.6m26.8-8.5h-4.5v12.5h1.9v-4.7h2.6c2.1 0 4.1-1.5 4.1-3.9s-2-3.9-4.1-3.9m-2.6 6h2.7c1.3 0 2.1-1.1 2.2-2.2 0-.9-.8-2.1-2.2-2.1h-2.7zm14.2-1.8c-1.4 0-2.8.6-3.3 1.9l1.7.7c.4-.7 1-.9 1.7-.9 1 0 1.9.6 2 1.6v.1c-.3-.2-1.1-.5-1.9-.5-1.8 0-3.6 1-3.6 2.8 0 1.7 1.5 2.8 3.1 2.8 1.3 0 1.9-.6 2.4-1.2h.1v1h1.8v-4.8c-.2-2.2-1.9-3.5-4-3.5m-1.7 5.8c0 .8.9 1.1 1.5 1.1 1 0 2-.8 2.2-2l-.149-.06c-.436-.178-.832-.34-1.551-.34-.9 0-2 .3-2 1.3m12-5.5-2.1 5.4h-.1l-2.2-5.4h-2l3.3 7.6-1.9 4.2h1.9l5.1-11.8zm-14.9 8h-1.9V17.4h1.9zM49.755 13.433l-.077-.543h-.029q-.474.65-1.377.65-.32 0-.582-.107a1.4 1.4 0 0 1-.456-.29 1.3 1.3 0 0 1-.301-.438 1.4 1.4 0 0 1-.106-.553q0-.883.718-1.324.718-.44 2.037-.44V10.3q0-.93-.978-.93-.698 0-1.229.348l-.213-.688q.65-.406 1.617-.407 1.85 0 1.85 1.95v1.736q0 .727.068 1.125h-.942m-.145-2.347q-.878 0-1.307.223-.429.225-.429.728 0 .369.202.553a.73.73 0 0 0 .512.184q.202 0 .386-.073a1 1 0 0 0 .322-.199 1 1 0 0 0 .228-.306.9.9 0 0 0 .086-.383zm6.073-2.367v.863h-1.96v3.851h-1.047V8.72zm5.994 2.3q0 .562-.155 1.027a2.4 2.4 0 0 1-.432.795q-.276.33-.659.514a1.9 1.9 0 0 1-.849.185q-.931 0-1.339-.669h-.02v2.483h-1.048v-5.083q0-.378-.01-.762a39 39 0 0 0-.028-.79h.921l.059.746h.02q.523-.843 1.591-.844.416 0 .771.174.354.175.616.49t.412.757.15.976m-1.066.038q0-.35-.083-.645a1.5 1.5 0 0 0-.242-.504 1.2 1.2 0 0 0-.388-.33 1.07 1.07 0 0 0-.51-.12q-.222 0-.437.096a1.2 1.2 0 0 0-.373.262q-.16.165-.257.398-.098.232-.098.495v.786q0 .261.083.485.082.224.232.388.15.165.359.257.208.092.46.092.592 0 .922-.45.331-.453.332-1.21m6.694-2.338v.001h-1.116l-.796 2.62q-.096.31-.155.547a6 6 0 0 1-.106.393h-.02q-.078-.281-.146-.514a6 6 0 0 0-.136-.417l-.893-2.629h-1.154l1.708 4.336a1 1 0 0 1 .058.223q0 .06-.077.213-.225.467-.592.776a2 2 0 0 1-.776.417l.252.882q.612-.106 1.155-.59.368-.341.771-1.083t.829-1.906l1.194-3.268m2.298 1.96h-.484v.66h.494q.272 0 .504.034.233.034.408.121a.7.7 0 0 1 .271.228.6.6 0 0 1 .096.344q0 .31-.285.52-.287.207-.82.207a2.4 2.4 0 0 1-.664-.092 2.8 2.8 0 0 1-.576-.228l-.273.69q.34.192.768.285.425.092.863.092.357 0 .736-.073a2.5 2.5 0 0 0 .693-.238 1.46 1.46 0 0 0 .52-.446q.204-.28.203-.698a.95.95 0 0 0-.105-.45 1.1 1.1 0 0 0-.281-.34 1.6 1.6 0 0 0-.393-.228 2 2 0 0 0-.451-.117v-.029q.183-.04.363-.122t.324-.213q.146-.13.232-.3a.84.84 0 0 0 .088-.393q0-.36-.16-.602a1.24 1.24 0 0 0-.412-.393 1.8 1.8 0 0 0-.576-.213 3.4 3.4 0 0 0-.646-.063 4 4 0 0 0-.809.083 2.9 2.9 0 0 0-.811.305l.271.678a3 3 0 0 1 .529-.228q.284-.091.566-.092.437.001.684.175a.54.54 0 0 1 .248.465q0 .281-.291.476-.29.195-.824.194m5.112-1.96v1.668q0 .573-.02 1.028t-.049.96l.02.02q.12-.242.24-.478l.004-.01.002-.003.117-.233q.181-.354.365-.723l1.164-2.23h1.357v4.713h-.99v-1.668q.001-.524.025-1.047.024-.524.053-1.058h-.049a7 7 0 0 1-.33.757q-.164.32-.328.66-.301.582-.598 1.164-.296.582-.625 1.193h-1.357V8.72zm8.73.863V8.72h-3.891v.863h1.426v3.851h1.03v-3.85zm5.334 1.528q.01-.121.01-.257a2.9 2.9 0 0 0-.137-.916 2 2 0 0 0-.393-.708 1.7 1.7 0 0 0-.619-.456 2 2 0 0 0-.811-.16q-.505 0-.918.194-.41.194-.703.534a2.5 2.5 0 0 0-.451.8 3.1 3.1 0 0 0-.158 1.004q0 .543.158.98.161.436.461.746t.738.48q.437.17.988.17.912 0 1.582-.29l-.164-.729a3.5 3.5 0 0 1-1.271.223q-.66 0-1.062-.364-.401-.364-.422-1.033h3.143q.02-.096.029-.218m-1.256-1.425q.267.344.266.897h-2.181q.05-.544.369-.893a1.01 1.01 0 0 1 .775-.349q.504 0 .771.345m6.204-1.005q-.436.03-.717.078v4.675q.251.02.625.04.372.02.762.02.349-.001.789-.04.442-.04.84-.185.398-.146.67-.437.27-.291.271-.786 0-.494-.32-.776-.32-.281-.834-.369l-.01-.029q.185-.038.354-.12.17-.083.301-.209a.916.916 0 0 0 .287-.679q0-.417-.225-.659a1.4 1.4 0 0 0-.553-.364 2.7 2.7 0 0 0-.693-.155 7 7 0 0 0-.654-.034q-.457 0-.893.03m.824 1.96h-.533V9.43q.214-.021.334-.03.123-.01.287-.01.571 0 .838.15a.5.5 0 0 1 .268.47.48.48 0 0 1-.092.296.65.65 0 0 1-.258.194q-.164.073-.383.106a3 3 0 0 1-.461.034m-.533 2.085q.194.019.324.03a4 4 0 0 0 .743-.02 1.5 1.5 0 0 0 .408-.11.75.75 0 0 0 .295-.223.58.58 0 0 0 .113-.37q-.001-.405-.359-.56-.359-.154-.971-.154h-.553z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "url(#GoogleRu_svg__paint0_linear_966_1797)",
                d: "M10.4 7.5c-.3.3-.5.8-.5 1.4V31c0 .6.2 1.1.5 1.4l.1.1 12.4-12.4v-.2z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "url(#GoogleRu_svg__paint1_linear_966_1797)",
                d: "m27 24.3-4.1-4.1v-.3l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "url(#GoogleRu_svg__paint2_linear_966_1797)",
                d: "M27.1 24.2 22.9 20 10.4 32.5c.5.5 1.2.5 2.1.1z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "url(#GoogleRu_svg__paint3_linear_966_1797)",
                d: "M27.1 15.8 12.5 7.5c-.9-.5-1.6-.4-2.1.1L22.9 20z"
            }),
            /*#__PURE__*/ jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "GoogleRu_svg__paint0_linear_966_1797",
                        x1: 17.436,
                        x2: -2.431,
                        y1: -7.427,
                        y2: -2.055,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#00A0FF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.007,
                                stopColor: "#00A1FF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.26,
                                stopColor: "#00BEFF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.512,
                                stopColor: "#00D2FF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.76,
                                stopColor: "#00DFFF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#00E3FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "GoogleRu_svg__paint1_linear_966_1797",
                        x1: 33.834,
                        x2: 9.637,
                        y1: 9.87,
                        y2: 9.87,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#FFE000"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.409,
                                stopColor: "#FFBD00"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.775,
                                stopColor: "#FFA500"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#FF9C00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "GoogleRu_svg__paint2_linear_966_1797",
                        x1: 10.083,
                        x2: -5.883,
                        y1: 13.514,
                        y2: 40.318,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#FF3A44"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#C31162"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "GoogleRu_svg__paint3_linear_966_1797",
                        x1: 0.683,
                        x2: 7.756,
                        y1: 4.08,
                        y2: 16.065,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#32A071"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.069,
                                stopColor: "#2DA771"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.476,
                                stopColor: "#15CF74"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.801,
                                stopColor: "#06E775"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#00F076"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
});

export { StoresHorizontalGoogleRu, StoresHorizontalGoogleRu as default };
